// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37mNQ","rootMobile":"styles_rootMobile__1IsBy"};